import ArrowButton from "@/components/Buttons/ArrowButton/ArrowButton";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import S from "./BlogCard.style";

export type Props = {
  item: {
    category: string;
    date: number;
    imageType: string;
    image: any;
    slug: string;
    text: string;
    title: string;
    url: string;
    fallbackImage?: string;
  };
};

const BlogCard = ({ item }: Props) => {
  const { category, date, image, text, url, imageType, fallbackImage } = item;

  const button = {
    url: url,
    target: "",
    title: "",
  };

  const formattedDate = (date: string) => {
    const stringDate =
      date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 8);

    const newDate = new Date(stringDate).toLocaleDateString("sv-SE", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    return newDate;
  };

  return (
    <S.LinkWrapper href={url}>
      <S.Card>
        {imageType === "gatsbyImage" && image ? (
          <GatsbyImage
            className="gatsby-image"
            image={image}
            alt={item.title}
          />
        ) : (
          <S.Image src={fallbackImage} alt={item.title} />
        )}
        <S.Category>
          <S.DetailsBig>{category && category}</S.DetailsBig>
        </S.Category>
        <S.HoverWrapper />
        <S.TextWrapper>
          <S.Date>{date && formattedDate(String(date))}</S.Date>
          <S.Title>{item.title && item.title}</S.Title>
          <S.Line />
          <S.PWrapper>
            <S.Paragraph
              dangerouslySetInnerHTML={{
                __html:
                  text &&
                  text
              }}
            />
          </S.PWrapper>
          <S.ArrowWrapper>
            <ArrowButton button={button} backgroundColor="black" noA={true} />
          </S.ArrowWrapper>
        </S.TextWrapper>
      </S.Card>
    </S.LinkWrapper>
  );
};

export default BlogCard;
